<template>
    <v-container
        class="narrative-template"
        fluid>
        <v-row
            align="start"
            align-content="center">
<!--            <v-card -->
<!--                flat -->
<!--                color="transparent"-->
<!--                v-if="$vuetify.breakpoint.smAndDown">-->
<!--                <v-card-title :class="`py-3 ${narrative.name}&#45;&#45;text`">-->
<!--                    {{!!narrative.title ? narrative.title : narrative.display}}-->
<!--                </v-card-title>-->
<!--                <v-card-text-->
<!--                    v-if="!!narrative.description">-->
<!--                    {{narrative.description}}-->
<!--                </v-card-text>-->
<!--            </v-card>-->
            <v-col
                v-if="$vuetify.breakpoint.smAndUp"
                cols="12"
                lg="7">
                <narrative-map
                    :state-stats="stateStats"
                    :narrative-names="narrativeTitles"
                    :narrative="narrative.name"
                    :narrative-totals="narrativeTotals"
                    :national-total="nationalStats.races.total">
                </narrative-map>
            </v-col>
            <v-col
                class="py-0"
                cols="12"
                lg="5">
                <v-row no-gutters>
                    <v-col
                        class="pa-0"
                        cols="12">
                        <div
                            :class="`narrative-template__title ${narrative.name}--text font-weight-bold my-2`">
<!--                            v-if="$vuetify.breakpoint.mdAndUp">-->
                            {{!!narrative.title ? narrative.title : narrative.display}}
                        </div>
                        <div
                            class="narrative-template__narrative-description mb-2"
                            v-if="$vuetify.breakpoint.mdAndUp">
                            {{ narrative.description }}
                        </div>
                        <stat-list
                            :color="narrative.name"
                            :stats="narrative.stats">
                        </stat-list>
                        <marketing-stories
                            v-if="$vuetify.breakpoint.smAndUp"
                            :color="narrative.name"
                            :is-technology="narrative.name === 'technology'"
                            :stories="stories">
                        </marketing-stories>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                v-if="$vuetify.breakpoint.xsOnly"
                cols="12"
                lg="7">
                <narrative-map
                    :state-stats="stateStats"
                    :narrative-names="narrativeTitles"
                    :narrative="narrative.name"
                    :narrative-totals="narrativeTotals"
                    :national-total="nationalStats.races.total">
                </narrative-map>
            </v-col>
            <v-col
                class="py-0"
                v-if="$vuetify.breakpoint.xsOnly">
                <marketing-stories
                    :color="narrative.name"
                    :stories="stories">
                </marketing-stories>
            </v-col>
            <call-to-action v-if="$vuetify.breakpoint.xsOnly"></call-to-action>
        </v-row>
        <total-template></total-template>
        <v-container
            v-if="$vuetify.breakpoint.xsOnly">
            <narrative-disclaimer
                :has-marketing-stats="false"
            ></narrative-disclaimer>
        </v-container>
    </v-container>
</template>

<script>
    import marketingStats from "../../constants/marketingStats";
    import { nationalStats } from '../../constants/nationalStats.js';

    import MarketingStories from "../marketing/MarketingStories";
    import NarrativeDisclaimer from "./NarrativeDisclaimer";
    import NarrativeMap from "../narrative/NarrativeMap.vue";
    import StatList from "../state/StatList";
    import TotalTemplate from "../totals/TotalTemplate";
    import CallToAction from "../header/CallToAction";

    export default {
        name: "narrative-template",
        props: {
            narrativeStats: Object,
            showStats: {
                type: Boolean,
                default: true,
            },
            stateStats: Object,
        },
        data(){
            return {
                marketingStats: marketingStats,
                nationalStats: nationalStats,
            }
        },
        components: {
            CallToAction,
            MarketingStories,
            NarrativeDisclaimer,
            NarrativeMap,
            StatList,
            TotalTemplate
        },
        computed: {
            narrative(){
                return this.narrativeStats[this.$route.name];
            },
            narrativeTitles(){
                let list = Object.keys(this.narrativeStats);
                return list;
            },
            narrativeTotals(){
                return this.nationalStats.narratives;
            },
            stories() {
                return marketingStats.filter(story => story.narrative === this.narrative.name);
            },
        },
    }
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";
    .narrative-template{
        &.container{
            align-items: start;
        }
        &__disclaimer{
            font-size: 12px;
        }
        &__title {
            font-size: 22px!important;
            @media screen and (min-width: $xl){
                font-size: 42px!important;
            }
        }
        &__narrative-description {
            font-size: 14px!important;
            @media screen and (min-width: $xl){
                font-size: 18px!important;
            }
        }
    }
</style>